import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import User from '../components/User';
import Location from '@material-ui/icons/Room';
import Address from '@material-ui/icons/LocationCity';
import Edit from '../assets/svg/profile SVGs/Icon feather-edit.svg';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import Phone from '@material-ui/icons/Phone';
import Name from '@material-ui/icons/Person';
import Org from '@material-ui/icons/Group';
import OrgId from '@material-ui/icons/CardMembership';
import { prov } from '../redux/constants';
import { updateUserProfileNonAuth } from '../redux/actions/userProfileActions';

const UserProfile = () => {
  const profile = useSelector((state) => state.userProfileReducer.userProfile);

  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const [editStyle, setEditStyle] = useState(false);
  const [openCamera, setOpenCamera] = useState(false);

  const [openProv, setOpenProv] = useState(false);

  const changeEditMode = () => {
    setDisabled(!disabled);
    setEditStyle(!editStyle);
    setOpenCamera(!openCamera);
  };

  const [newField, setNewField] = useState({
    fullName: profile.fullName,
    phoneNumber: profile.phoneNumber,
    province: profile.province,
    city: profile.city,
    organizationName: profile.organizationName,
    organizationId: profile.organizationId,
  });
  const handleChangeNonAuth = (event) => {
    setNewField({
      ...newField,
      [event.target.name]: event.target.value,
    });
  };
  const chooseProv = (value) => {
    setNewField({
      ...newField,
      province: value,
    });
    setOpenProv(!openProv);
  };
  const toggleProv = () => {
    setOpenProv(!openProv);
  };
  const updateProfileNonAuth = (newField) => {
    setDisabled(!disabled);
    setEditStyle(!editStyle);
    dispatch(updateUserProfileNonAuth(newField));
  };

  return (
    <div className='text-gray-700 '>
      <User openCamera={openCamera} />
      <div className='mb-32'>
        <div className='flex justify-start md:pl-32 pl-4 -mt-8 pb-3 outline-none '>
          <button onClick={changeEditMode} className='outline-none'>
            <img src={Edit} alt='Edit' />
          </button>
        </div>

        <div className='md:mx-48 pb-4'>
          <div className='flex justify-end px-6 pt-4 flex items-center '>
            <input
              type='text'
              className={`mr-4 bg-white outline-none  ${
                editStyle ? 'border-b-2 border-blue-500 ' : ''
              }`}
              defaultValue={profile.fullName}
              name='fullName'
              onChange={handleChangeNonAuth}
              disabled={disabled}
              dir='rtl'
            />
            <Name alt='Name' />
          </div>
          <div className='flex justify-end px-6 pt-4 flex items-center'>
            {!disabled ? (
              <div className='focus:outline-none mr-4 w-40'>
                <div
                  className=' flex  justify-between items-center border rounded-lg n-blue  px-4 focus:outline-none'
                  tabIndex={0}
                  role='button'
                  onKeyPress={toggleProv}
                  onClick={toggleProv}
                >
                  <div>
                    <p className='pr-4'>{newField.province}</p>
                  </div>

                  {openProv ? (
                    <ArrowDown
                      alt='arrow'
                      style={{ fontSize: 40, color: 'black' }}
                    />
                  ) : (
                    <ArrowRight
                      alt='arrow'
                      style={{ fontSize: 40, color: 'black' }}
                    />
                  )}
                </div>
                {openProv && (
                  <div className=' h-32 overflow-y-scroll scrolling-touch overflow-x-hidden z-50 scrollbar-thumb'>
                    <ul className='border-2 rounded-lg n-blue bg-white'>
                      {prov.map((item) => {
                        return (
                          <li
                            key={item.id}
                            className='border-b-2 n-blue  px-4 py-2 focus:outline-none'
                          >
                            <div
                              type='button'
                              onClick={() => chooseProv(item.value)}
                              className=' flex justify-between cursor-pointer'
                            >
                              <span>{item.value}</span>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            ) : (
              <input
                type='text'
                className={`mr-4 bg-white outline-none ${
                  editStyle ? 'border-b-2 border-blue-500' : ''
                }`}
                defaultValue={profile.province}
                name='province'
                disabled={disabled}
                dir='rtl'
              />
            )}

            <Location alt='loction' />
          </div>
          <div className='flex justify-end px-6 pt-4 flex items-center'>
            <input
              type='text'
              className={`mr-4 bg-white outline-none ${
                editStyle ? 'border-b-2 border-blue-500' : ''
              }`}
              defaultValue={profile.city}
              name='city'
              onChange={handleChangeNonAuth}
              disabled={disabled}
              dir='rtl'
            />
            <Address alt='Address' />
          </div>
          <div className='flex justify-end px-6 pt-4 flex items-center'>
            <input
              type='text'
              className={`mr-4 bg-white outline-none ${
                editStyle ? 'border-b-2 border-blue-500' : ''
              }`}
              defaultValue={profile.phoneNumber}
              name='phoneNumber'
              onChange={handleChangeNonAuth}
              disabled={disabled}
              dir='rtl'
            />
            <Phone alt='Phone' fontSize='small' />
          </div>
          {/* <div className="flex justify-end px-6 pt-4 flex items-center">
            <p
              className={`mr-4 text-sm pt-1 ${
                editStyle ? "text-blue-500 cursor-pointer" : "cursor-default"
              }`}
            >
              test@test.com
            </p>
            <Email alt="Email" fontSize="small" />
          </div> */}
          {profile.hasOrganization ? (
            <div>
              <div className='flex justify-end px-6 pt-4 flex items-center'>
                <input
                  type='text'
                  className={`mr-4 bg-white outline-none ${
                    editStyle ? 'border-b-2 border-blue-500 ' : ''
                  }`}
                  defaultValue={profile.organizationName}
                  name='organizationName'
                  onChange={handleChangeNonAuth}
                  disabled={disabled}
                  dir='rtl'
                />
                <Org alt='Org' fontSize='small' />
              </div>
              <div className='flex justify-end px-6 pt-4 flex items-center'>
                <input
                  type='text'
                  className={`mr-4 bg-white ${
                    editStyle ? 'border-b-2 border-blue-500' : ''
                  }`}
                  defaultValue={profile.organizationId}
                  onChange={handleChangeNonAuth}
                  name='organizationId'
                  disabled={disabled}
                  dir='rtl'
                />
                <OrgId alt='Org id' fontSize='small' />
              </div>
            </div>
          ) : null}

          <div
            className={`flex justify-center p-8 ${editStyle ? '' : 'hidden'}`}
          >
            <button
              type='button'
              onClick={() => updateProfileNonAuth(newField)}
              className='blue-bg border text-white rounded-lg p-1 w-24 focus:outline-none'
            >
              حفظ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserProfile;
